import { Colaborador } from '@/store/catalogos/colaborador';
import { DepartamentoModel } from '@/store/catalogos/departamento';
import { Util } from '@/utils/util';
import { DatePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CatalogoColaboradorService } from '@services/catalogo/catalogoColaborador.service';
import { CatalogoDepartamentoService } from '@services/catalogo/catalogoDepartamento.service';
import { ValidatorsService } from '@services/util/validators.service';
import { map, Observable, startWith } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-formulario-departamento',
  templateUrl: './formulario-departamento.component.html',
  styleUrls: ['./formulario-departamento.component.scss']
})
export class FormularioDepartamentoComponent {

  form: FormGroup;
  mostrarBoton: boolean = true;
  title = "Nuevo Departamento";

  colaboradorControl = new FormControl<string>('', Validators.required); // Control para el campo de búsqueda
  colaboradorList: Colaborador[] = []; // Lista de colaboradores
  filteredColaboradores$: Observable<Colaborador[]>; // Observable para los colaboradores filtrados

  constructor(
    private util: Util,
    private datePipe: DatePipe,
    private catalogoService: CatalogoColaboradorService,
    private departamentoService: CatalogoDepartamentoService,
    public dialogRef: MatDialogRef<FormularioDepartamentoComponent>,
    private spinner: NgxSpinnerService,
    private validatorsService: ValidatorsService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {


    if (data.update) {
      this.title = "Modificar Departamento";
    }
    if (data.view) {
      this.title = "Vista Departamento";
    }
  }

  ngOnInit(): void {
    this.buildForm(this.data?.row);
      this.colaboradorLista().then(() => {
  });
    this.colaboradorLista();


    this.filteredColaboradores$ = this.colaboradorControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || ''))
    );
  }

  // Cargar la lista de colaboradores
colaboradorLista(): Promise<void> {
  return new Promise((resolve, reject) => {
    this.catalogoService.getAll().subscribe({
      next: data => {
        this.colaboradorList = data;

        // Si estamos en modo "update" o "view", establecer el valor inicial
        if (this.data?.row?.colaborador?.idColaborador) {
          const colaboradorSeleccionado = this.colaboradorList.find(
            (col) => col.idColaborador === this.data?.row?.colaborador?.idColaborador
          );
          if (colaboradorSeleccionado) {
            this.colaboradorControl.setValue(
              `${colaboradorSeleccionado.nombre} ${colaboradorSeleccionado.apellidoPaterno} ${colaboradorSeleccionado.apellidoMaterno}`
            );
            this.form.get('colaborador')?.setValue(colaboradorSeleccionado.idColaborador);
          }
        }

        resolve(); // ✅ Finaliza la promesa correctamente
      },
      error: error => {
        this.util.errorMessage("Error al obtener lista de colaboradores.");
        resolve(); // Aún si falla, resolvemos para no dejar colgado el flujo
      }
    });
  });
}


  // Método de filtrado
  private _filter(value: string): Colaborador[] {
    const filterValue = value.trim().toLowerCase();
    return this.colaboradorList.filter(colaborador =>
      (`${colaborador.nombre} ${colaborador.apellidoPaterno} ${colaborador.apellidoMaterno}`)
        .toLowerCase()
        .includes(filterValue) ||
      colaborador.idColaborador.toString().includes(filterValue)
    );
  }


  seleccionarColaborador(event: any) {
    const colaboradorSeleccionado = event.option.value; 
    if (colaboradorSeleccionado) {
      this.colaboradorControl.setValue(
        `${colaboradorSeleccionado.nombre} ${colaboradorSeleccionado.apellidoPaterno} ${colaboradorSeleccionado.apellidoMaterno}`
      );

      this.form.get('colaborador')?.setValue(colaboradorSeleccionado.idColaborador);
    }
  }


  private buildForm(data: DepartamentoModel): void {    
    this.form = new FormGroup({
      idArea: new FormControl(data?.idArea ?? null),
      nombreDepartamento: new FormControl(data?.nombreArea ?? '', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(50)]
      }),
      colaborador: new FormControl(data?.colaborador?.idColaborador ?? '', {
        nonNullable: true,
        validators: [Validators.required]
      })
    });

    if (this.data.view) {
      this.form.disable();
      this.mostrarBoton = false;
      this.colaboradorControl.disable();
    }
  }

 
  isValidField(field: string): boolean {
    return this.form?.controls[field]?.invalid && this.form?.controls[field]?.touched;
  }


  getFieldError(field: string): string {
    return this.validatorsService.getFieldError(this.form, field);
  }

  abrirAutocomplete() {
    if (!this.colaboradorControl.value) {
      this.colaboradorControl.setValue(' '); 
      this.colaboradorControl.setValue('');
    }
  }


  // enviar(): void {
  //   if (this.form.invalid) {
  //     this.form.markAllAsTouched();
  //     return;
  //   }

  //   const departamento: DepartamentoModel = this.formToModel();

  //   const request = this.data.insert
  //     ? this.departamentoService.create(departamento)
  //     : this.departamentoService.update(departamento);


  //   request.subscribe(response => {
  //     if (response.success) {
  //       this.util.successMessage("Registro guardado con éxito!");
  //       this.dialogRef.close({ data: response });
  //     } else {
  //       const errorMsg = this.util.isEmpty(response.message)
  //         ? "Ocurrió un error al guardar el registro"
  //         : response.message;
  //       this.util.errorMessage(errorMsg);
  //     }
  //   });
  // }

  enviar(): void {
  if (this.form.invalid) {
    this.form.markAllAsTouched();
    return;
  }

  const departamento: DepartamentoModel = this.formToModel();

  const request = this.data.insert
    ? this.departamentoService.create(departamento)
    : this.departamentoService.update(departamento);

  request.subscribe(response => {

    if (response.success) {
      this.util.successMessage("Registro guardado con éxito!");
      this.dialogRef.close({ data: response });
    } else {
      const errorMsg = this.util.isEmpty(response.message)
        ? "Ocurrió un error al guardar el registro"
        : response.message;
      this.util.errorMessage(errorMsg);
    }
  }, error => {
    this.util.errorMessage("Error en la operación.");
  });
}


  private formToModel(): DepartamentoModel {
    const formValues = this.form.getRawValue();

    return {
      idArea: formValues.idArea ?? '',
      nombreArea: formValues.nombreDepartamento ?? '',
      colaborador: {
        idColaborador: formValues.colaborador ?? ''
      }
    };
  }
}